import Head from 'next/head'
import { useEffect, useState } from 'react'
import RegisterForm from '@/components/forms/auth/Register'
import { useRouter } from 'next/router'
import { getSession, useSession } from 'next-auth/react'
import BodyTwo from '@/components/portal/ui/typography/BodyTwo'
import HeadingTwo from '@/components/portal/ui/typography/HeadingTwo'
import { GetServerSidePropsContext } from 'next'
import { UserRoleEnum } from '@/types/cognito'

const Register = () => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [sharedValues, setSharedValues] = useState({
    email: '',
  })
  const router = useRouter()
  const { data: session, status } = useSession()

  useEffect(() => {
    if (status === 'authenticated') router.push('/portal/account')
  }, [session])

  return (
    <div className="flex justify-center h-[784px] pt-20 w-full">
      <Head>
        <title>Register | North Park Transportation</title>
      </Head>

      <span className="mx-auto">
        {!showConfirmation ? (
          <RegisterForm
            setShowConfirmation={setShowConfirmation}
            setSharedValues={setSharedValues}
          />
        ) : (
          <div className="flex flex-col items-center justify-center w-full sm:w-[457px] mx-auto text-center">
            <HeadingTwo
              fontSize="text-2xl"
              additionalClasses="my-3"
              fontWeight="font-ttHovesBold"
            >
              Thank you for registering your account.
            </HeadingTwo>

            <div className="flex flex-col justify-center px-3 sm:px-0 mt-8 mb-28 w-full sm:w-[437px]">
              <BodyTwo
                additionalClasses="text-center whitespace-pre-line"
                fontSize="text-base"
              >
                Once the account team at NPT reviews your account details
                (usually within 24 hours) we will send you a follow up email at{' '}
                <span className="font-ttHovesMedium text-green-portal">
                  {sharedValues.email}
                </span>{' '}
                with a link to set your password and sign in.
              </BodyTwo>
              <BodyTwo
                additionalClasses="text-center mt-6 w-[78%] mx-auto"
                fontSize="text-base"
              >
                If you have any questions please contact NPT’s IT support team
                at
                <span>
                  {' '}
                  <a
                    href="mailto:it@nopk.biz"
                    className="text-green-portal"
                    rel="noopener noreferrer"
                  >
                    it@nopk.biz
                  </a>
                </span>
              </BodyTwo>
            </div>
          </div>
        )}
      </span>
    </div>
  )
}

export default Register

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req } = context
  const session = await getSession({ req })

  if (session && session?.user?.role === UserRoleEnum.NOPK_ADMIN) {
    return {
      redirect: {
        destination: '/portal/admin',
        permanent: false,
      },
    }
  }

  if (session && session?.user?.userID) {
    return {
      redirect: {
        destination: '/portal/account',
        permanent: false,
      },
    }
  }

  return {
    props: {},
  }
}
